import { connect } from 'react-redux';
import { App } from '../../types/app';

export default connect(({ app: { accessToken } }: { app: App }) => ({
  accessToken,
}));
